declare global {
  interface Window {
    _env_: any;
  }
}

export const environment = {
  // helmet meta data
  metaTitle: window._env_.REACT_APP_META_TITLE,
  metaDescription: window._env_.REACT_APP_META_DESC,
  metaUrl: window._env_.REACT_APP_META_URL,
  metaImg: window._env_.REACT_APP_META_IMG,
  metaImgAlt: window._env_.REACT_APP_META_IMG_ALT,
  //
  apiUrl: window._env_.REACT_APP_API_URL,
  clientId: window._env_.REACT_APP_IS_CLIENT,
  authority: window._env_.REACT_APP_IS_URL,
  scope: window._env_.REACT_APP_IS_SCOPE,
  silentLoginTimeout: 20000, // ms
  defaultCoords: {
    lat: 51.505717,
    lng: -0.1269986,
  },
  apiKey: window._env_.REACT_APP_GMAPS_KEY,
  siteIconBaseUrl: window._env_.REACT_APP_SITE_ICON_URL,
  useLocalTranslations: window._env_.REACT_APP_USE_LOCAL_TRANSLATIONS,
  defaultLocale: 'en-GB',
  imageExtensions: ['.jpeg', '.jpg', '.gif', '.png'],
  gisExtensions: ['.zip'],
  maxImageFileSize: 1024 * 1024 * 5, //5 MB,
  appName: 'PermaNetWeb',
  urlDateFormat: 'yyyy-MM-dd',
  gisImport: {
    pollingIntervalMilliseconds: 1500,
    warnUserAfterAttemptsCount: 20,
  },
  sessionCookieDomain: window._env_.REACT_APP_SESSION_COOKIE_DOMAIN,
  sessionCookieSecure: Boolean(window._env_.REACT_APP_SESSION_COOKIE_SECURE),
  sessionCookieIdleTimeout: Number(window._env_.REACT_APP_SESSION_COOKIE_IDLE_TIMEOUT),
  gisManagementUrl: window._env_.REACT_APP_GIS_MANAGEMENT_URL,
  dataViewRedirectUrl: window._env_.REACT_APP_DV_REDIRECT_URL,
  dataViewRedirectTarget: 'dv_target',
  version: window._env_.REACT_APP_VERSION,
  maximumCorrelationLeakPathSegments: 500,
  useMetric: window._env_.REACT_APP_USE_METRIC === 'true',
  //
  zoomLevelOnSingleSite: 18,
  zoomLevelMastOnly: 15,
  zoomForClusters: 14,
  zoomForDmaClusters: 12,
  minMapZoom: 3,
  //
  clarityId: window._env_.REACT_APP_CLARITY_ID,
};
